<div class="row files-view" (window:resize)="resize()" #root_div>
  @for (file of imageFiles(); track file.id; let file_index = $index) {
    <div [class.attach-invisible]="file_index > 3" data-cy="thumbs">
      <div class="attach" (click)="onFileClick(file)">
        <img src="{{ file.thumbnail }}" data-cy="thumb-img" />
        @if (showShadowBox(file_index)) {
          <div class="overlay"></div>
          <p class="number-attach">+{{ imageFiles().length - 3 }}</p>
        }
      </div>
      @if (!showShadowBox(file_index)) {
        <p class="file-name" data-cy="thumb-file-name" (click)="onFileClick(file)">{{ file.file_name }}</p>
      }
    </div>
  }
  @for (file of notImageFiles(); track file.id) {
    <div>
      <div class="attach" (click)="onFileClick(file)">
        <div class="file-format"><i [ngClass]="file.file_name | fileIconClass" data-cy="attach-format"></i></div>
        @if (!file.canPreview() && !file.isPdf()) {
          <a class="action-file">
            <i class="fa fa-download"></i>
          </a>
        }
      </div>
      <p class="file-name" data-cy="attach-name" (click)="onFileClick(file)">{{ file.file_name }}</p>
    </div>
  }
  <app-gallery [items]="previewFiles()" #gallery></app-gallery>
</div>
